import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import axios from "axios";

import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { connect } from "react-redux";
import appConfig from '../../config/config';
import {FormSubmit} from '../common/formsubmit';
import LienForm from "./LienForm";
import { IoT1ClickProjects } from "aws-sdk";
const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'Grantee', text: 'Plaintiff' },
    { dataField: 'Grantor', text: 'Defendant' },
    { dataField: 'Prior', text: 'UCC' },
    { dataField: 'DEEDDATE', text: 'Rec Date' },
    { dataField: 'RECDATE', text: 'Lien Amount' },
    { dataField: 'VOLINST', text: 'Docket-case' },
    { dataField: 'VOLINST', text: 'Docket Date' },
    { dataField: 'VOLINST', text: 'Vol-Inst' },
    { dataField: 'PAGE', text: 'Page' }
];
var orderColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });



class PropertyReportLien extends Component {


    constructor(...args) {
        super(...args);
        this.state = {
            display:true
            // showBanner: false, message: '', IsDataLoaded: false, OrderData: {}
        };
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    errorf=(error)=>{
    }
    successf=(response) =>{
    }
    submit = (values) => {
         FormSubmit(values,appConfig.apiGateway.updatePropertyReport, 
            this.props, "Lien", this.errorf, this.successf);
    }

    selectRow(Id) {
    }
    render() {
        return (
            <>
            <Modal
                isOpen={this.state.display}
                toggle={this.toggle}
                contentClassName="custom-large-modal-style"
              >
            <form onSubmit={this.props.handleSubmit(this.submit)} style={{ marginLeft: "0%", marginRight: "5%" }}>
            <ModalHeader>Add Lien</ModalHeader>
            <ModalBody>
                <LienForm></LienForm>
            </ModalBody>
            <ModalFooter>

                <div className="col-12 pb-2 text-right">
                    <Button color="primary" type="submit" className="mr-3">Save</Button>
                    <Button type="button" onClick={()=> this.props.Add(false)}>Cancel</Button>
                </div>
            </ModalFooter>
            </form>
            </Modal>
            </>
        );
    }
}

const validate = (formValues) => {
    const errors = {};

    return errors;
}
var propertyReportLienForm = reduxForm({
    form: 'propertyReportLienForm',
    validate
})(PropertyReportLien);

propertyReportLienForm = connect(
    state => ({
        session: state.session
    })
)(propertyReportLienForm);

export default propertyReportLienForm;